<template>
  <div :class="`${$root.parent.get('slimView') ? 'card-slim' : ''} ${!chore.get('done') && this.$props.mode !== 'kids' ? 'card  cf0' : 'card  cs1'
  }`" v-if="isVisible" :style="`background-image: ${typeof chore.get('image') == 'string'
    ? 'url(' + chore.get('image') + ')'
    : 'url(/images/chores/chorebg.jpg)'
  };`">
    <div class="overlay"></div>
    <div class="card-header">
      <div>
        <h3>{{ chore.get("name") }}</h3>
        <p v-if="!chore.get('done')">{{ chore.get("description") }}</p>
        <p v-else>🎉 Chore Complete | Tap To Confirm 🎉</p>
      </div>
      <div v-if="chore.get('done')">
        <div class>✅</div>
      </div>
      <div v-else class="fhr fhr-clock"></div>
    </div>
    <div class="card-footer">
      <p>{{ $tc("chore.points", chore.get("points"), { count: chore.get("points") }) }}</p>
      <span v-if="chore.get('repeats') !== '0.0.0.0.0.0.0'" style="text-align: right">
        <span v-for="(day, index) of chore.get('repeats').split('.')" :key="day + index + 'dow'"
          :class="day !== '1' ? 'dayOfWeek ' : 'dayOfWeek dayOfWeek-active'">
          {{
  [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
          ][index][0]
          }}
        </span>
      </span>
    </div>
  </div>
</template>

<script>
import * as ModernModals from "modern-modals";
export default {
  name: "chore",
  props: ["chore", "mode", "isFuture"],
  data() {
    return {
      isVisible: false
    };
  },
  mounted() {
    let _this = this;
    let timer, touchMoved;
    try {
      const chore = this.$props.chore;
      const dayOfWeek = new Date().getDay();
      let schedule = chore.get("repeats").split(".");
      let isVisibleToday =
        chore.get("done") ||
        ((chore.get("repeats") == "0.0.0.0.0.0.0" ||
          schedule[dayOfWeek] == "1") &&
          (typeof chore.get("dateConfirmed") == "undefined" ||
            chore.get("dateConfirmed") !== new Date().toDateString()));
      this.$data.isVisible =
        this.$props.mode == "kids" && chore.get("done")
          ? false
          : (this.$props.isFuture == "yes" && !isVisibleToday) ||
          (this.$props.isFuture !== "yes" && isVisibleToday);
      setTimeout(() => {
        function down(e) {
          //  e.stopPropagation()
          let pushLength = Number(new Date());
          timer = setInterval(() => {
            if (Number(new Date()) - Number(pushLength) >= 250) {
              clearInterval(timer);
              if (touchMoved) return;
              if (!_this.$route.path.includes("kids")) _this.removeChore();
            }
          }, 10);
        }
        function up(e) {
          e.stopPropagation();
          touchMoved = false;
          clearInterval(timer);
        }
        this.$el.addEventListener("mousedown", down, false);
        this.$el.addEventListener("touchstart", down, true);
        this.$el.addEventListener("mouseup", up, false);
        this.$el.addEventListener("touchend", up, false);
        this.$el.addEventListener("touchmove", () => (touchMoved = true));
        this.$el.addEventListener("contextmenu", e => e.preventDefault());
      }, 10);
    } catch { }
  },
  methods: {
    removeChore() {
      ModernModals.prompt(this.$t("pages.parents.deleteChore")).then(answer => {
        if (answer) {
          this.$props.chore.destroy();
          this.$root.initLoadChores();
        } else {
          this.$root.initLoadChores();
        }
      });
    }
  }
};
</script>
